import React from "react";
import { questionContext } from "../providers/QuestionProvider";

function useQuestion() {
  const question = React.useContext(questionContext);

  return question;
}
export default useQuestion;
